import {
  ERentioMoveServiceStatus,
  IContract,
} from "@rentiohq/shared-frontend/dist/types/contract.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import StatusDot, { EStatus } from "../StatusDot";

interface IProps {
  contract: IContract;
  hasFeature: boolean;
}

export const StatusDotRentioMove = (props: IProps) => {
  const { contract, hasFeature } = props;

  // Helpers
  const getStatus = () => {
    if (contract.manuallyCompletedMove) {
      return EStatus.Success;
    }

    if (!hasFeature) {
      return EStatus.Error;
    }

    switch (contract.rentioMoveStatus || ERentioMoveServiceStatus.None) {
      default:
      case ERentioMoveServiceStatus.None:
        return EStatus.Error;

      case ERentioMoveServiceStatus.Processing:
        return EStatus.Warning;

      case ERentioMoveServiceStatus.Sent:
        return EStatus.Success;
    }
  };

  // Render
  const renderTooltipContent = () => {
    if (contract.manuallyCompletedMove) {
      return getLocalizedText(contract.manuallyCompletedMove);
    }

    if (!hasFeature) {
      return getLocalizedText("system.unchecked");
    }

    if (!contract) {
      return;
    }

    const { rentioMoveStatus } = contract;
    return getLocalizedText(
      `rentio_move_service.status.${
        rentioMoveStatus || ERentioMoveServiceStatus.None
      }`.toLowerCase(),
    );
  };

  return (
    <StatusDot status={getStatus()} tooltipContent={renderTooltipContent()} />
  );
};
